module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 63.657 63.657"
    },
    attrs: {
      "viewBox": "0 0 63.657 63.657",
      "xml:space": "preserve",
      "width": "512px",
      "height": "512px"
    }
  }, [_c('g', [_c('g', [_c('g', [_c('g', [_c('polygon', {
    attrs: {
      "points": "31.891,63.657 0.012,35.835 2.642,32.821 31.886,58.343 61.009,32.824 63.645,35.832",
      "fill": _vm.fillColor
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('rect', {
    attrs: {
      "x": "29.827",
      "width": "4",
      "height": "60",
      "fill": _vm.fillColor
    }
  })])])]), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g')]), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g'), _vm._v(" "), _c('g')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-338435ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Arrow.vue
// module id = 11
// module chunks = 0